import { Box, Flex, Text } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import React, { useState } from 'react';

import {
  SearchIconButton,
  EditIconButton,
  SaveIconButton,
  XIconButton,
} from 'packages/common-frontend/components/IconButton';
import { WipConfig } from 'packages/creditAgreements/ui/types';

export const QueryStringContainer: React.FC<{
  wipConfig?: WipConfig;
  queryString: string;
  fullPropertyKey: string;
  changeQueryString: (newQueryString: string) => void;
  executeQueryMethod: () => void;
}> = ({
  wipConfig,
  queryString,
  fullPropertyKey,
  changeQueryString,
  executeQueryMethod,
}) => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);
  const [queryStringState, setQueryStringState] = useState<string>(queryString);

  return (
    <Box id="query-string-full-container" mb="5">
      <Flex alignItems="center">
        <Text fontWeight="bold" mr="2">
          SQL Query
        </Text>

        {wipConfig?.isMutateAllowed(fullPropertyKey) && (
          <>
            {isEditOpen ? (
              <>
                <SaveIconButton
                  ariaLabel="save and close"
                  label="Save and Close"
                  onClick={() => {
                    changeQueryString(queryStringState);
                    setIsEditOpen(false);
                  }}
                />
                <XIconButton
                  ariaLabel="close edit"
                  label="Close Edit"
                  onClick={() => {
                    setQueryStringState(queryString);
                    setIsEditOpen(false);
                  }}
                />
              </>
            ) : (
              <>
                <EditIconButton
                  ariaLabel="edit query"
                  label="Edit Query"
                  onClick={() => setIsEditOpen(true)}
                />
                <SearchIconButton
                  ariaLabel="execute query"
                  label="Execute Query"
                  onClick={executeQueryMethod}
                />
              </>
            )}
          </>
        )}
      </Flex>

      {wipConfig?.isMutateAllowed(fullPropertyKey) && (
        <>
          <Text fontStyle="italic" fontSize="sm">
            Need to set up above attributes before attemping to save SQL query.
          </Text>
          <Text fontStyle="italic" fontSize="sm">
            Afterwards, execute query in order to determine column names (saved
            as part of config)
          </Text>
        </>
      )}

      <Box border="1px" borderColor="gray.700" p="3" mt="3">
        {wipConfig?.isMutateAllowed(fullPropertyKey) && isEditOpen ? (
          <Box
            resize="vertical"
            minH="200px"
            h="200px"
            maxH="400px"
            overflowY="auto"
            pr="1"
            pb="1"
          >
            <Editor
              language="sql"
              value={queryStringState}
              onChange={(val) => setQueryStringState(val ?? '')}
              theme="vs-dark"
              options={{
                fixedOverflowWidgets: true,
                minimap: { enabled: false },
              }}
            />
          </Box>
        ) : (
          <Box as="pre" px="3" h="200px" fontSize="sm" overflowY="auto">
            {queryString}
          </Box>
        )}
      </Box>
    </Box>
  );
};
